/**
 * These are errors which we ignore from SLO reporting to ensure we reporting on errors we can action
 */
const skippedErrors = [
	/failed to fetch/i,

	/Fetch call failed with status code: 401/i,

	/NetworkError when attempting to fetch resource./i,

	/The operation was aborted./i,
];

export function shouldSkipErrorReporting(error: Error) {
	// Just checks that none of our non slo errors match the error
	return skippedErrors.some((msg) => msg.test(error.message));
}
